import React from "react";

export default function DollarSignIcon({
	color = "#1A1C21",
	width = 20,
	height = 20,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_6553_67274)">
				<g clipPath="url(#clip1_6553_67274)">
					<path
						d="M9.06068 14.376C9.21535 14.2673 9.42068 14.066 9.42068 13.5666C9.42068 13.212 9.18002 12.9993 8.66602 12.7793V14.552C8.81602 14.506 8.95402 14.4513 9.06068 14.376Z"
						fill={color}
					/>
					<path
						d="M8 4C3.58867 4 0 7.58867 0 12C0 16.4113 3.58867 20 8 20C12.4113 20 16 16.4113 16 12C16 7.58867 12.4113 4 8 4ZM10.7547 13.5673C10.7547 14.6 10.2507 15.1707 9.82733 15.468C9.496 15.7007 9.09667 15.8393 8.66667 15.9193V17.3333H7.33333V15.9753C6.566 15.9173 5.78333 15.7347 5.10667 15.4907L4.48 15.2647L4.93267 14.0107L5.56 14.2373C6.17333 14.4587 6.78267 14.5907 7.33333 14.6413V12.302C6.274 11.922 5.09867 11.3287 5.09867 9.82067C5.09867 9.06867 5.44733 8.448 6.08133 8.07333C6.44267 7.86 6.87733 7.74467 7.33333 7.69067V6.66667H8.66667V7.70067C9.45133 7.792 10.17 8.00733 10.5707 8.22867L11.1553 8.54933L10.5133 9.718L9.92933 9.39667C9.64067 9.238 9.16933 9.10867 8.66667 9.03867V11.348C9.68533 11.708 10.7547 12.2293 10.7547 13.5673Z"
						fill={color}
					/>
					<path
						d="M6.76031 9.22178C6.53031 9.35778 6.43164 9.53644 6.43164 9.82044C6.43164 10.3251 6.71764 10.6004 7.33297 10.8678V9.03711C7.11431 9.07511 6.91297 9.13111 6.76031 9.22178Z"
						fill={color}
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_6553_67274">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 4)"
					/>
				</clipPath>
				<clipPath id="clip1_6553_67274">
					<rect
						width="16"
						height="16"
						fill="white"
						transform="translate(0 4)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
